<template>
  <div class="store-select">
    <div class="search" v-if="allStores.length > 5">
      <AdornmentsInput
        v-model="searchWord"
        class="search-input"
        placeholder="店舗名"
        :prefixIcon="SearchIcon"
        :suffixIcon="!!searchWord ? CloseIcon : null"
        @onClickSuffix="clearSearchWord"
      />
    </div>
    <ul v-if="stores.length" class="stores">
      <li
        v-close-popover
        v-for="store in stores"
        :key="store.id"
        class="store"
        :class="{ selected: store.id === (current ? current : store.isSelected) }"
        @click="handleSelect(store.id)"
      >
        {{ store.name }}
      </li>
    </ul>
    <div v-else class="no-data">該当する店舗はありません</div>
    <footer v-if="showLogout">
      <Button v-close-popover class="logout" @click="handleLogout" :flat="isSP">ログアウト</Button>
    </footer>
  </div>
</template>

<script>
import { orderBy } from 'lodash'
import { mapGetters } from 'vuex'
import Button from '@/components/atoms/Button'
import SearchIcon from '@/components/icons/search'
import CloseIcon from '@/components/icons/close'
import AdornmentsInput from '@/components/molecules/AdornmentsInput'
import Dialog from '@/components/molecules/ModalDialog'
import { ClosePopover } from '@/components/molecules/Popover'

/* ネイティブ mock */
if (STAGE <= STAGE_DEV) {
  require('@/utils/mock').nativeMock('setUserId', 'setPassword')
}

export default {
  name: 'StoreSelect',
  directives: {
    ClosePopover,
  },
  components: {
    Button,
    AdornmentsInput,
  },
  props: {
    current: Number,
    showLogout: Boolean,
    isSP: Boolean,
  },
  data() {
    return {
      searchWord: '',
      SearchIcon,
      CloseIcon,
    }
  },
  computed: {
    ...mapGetters({
      allStores: 'stores/all',
    }),
    stores() {
      return orderBy(
        this.allStores.filter(store => String(store.name).includes(this.searchWord)),
        [this.id],
      )
    },
  },
  methods: {
    async handleSelect(id) {
      /**
       * 店舗の選択
       * @event select
       * @type {number}
       */
      if (!this.$store.state.app.editing) {
        this.$emit('select', id)
        return
      }

      if (await Dialog.confirmLeaveSetting(this.$route.path)) {
        this.$emit('select', id)
      }
    },
    handleLogout() {
      this.$emit('logout')
    },
    clearSearchWord() {
      this.searchWord = ''
    },
  },
}
</script>

<style lang="postcss" scoped>
.search {
  border-bottom: 1px solid var(--border-color);
  box-sizing: initial;
  padding: 8px;
  width: 320px;

  .sp & {
    box-sizing: border-box;
    height: 56px;
    width: 100%;
  }
}

.search-input {
  border: 1px solid var(--dark-gray);
  height: 40px;
  padding: 0 8px 0 16px;

  .sp & {
    padding-left: 8px;
  }

  >>> input {
    font-size: 13px;

    &::-webkit-input-placeholder {
      color: var(--light-gray);
    }
  }
}

.store-select {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - (80px + 56px));
  overflow: hidden;

  @media screen and (max-width: 768px) {
    flex: 1 1 auto;
    max-height: initial;
  }
}

.stores {
  flex-grow: 1;
  -webkit-overflow-scrolling: scroll;
  overflow-y: scroll;
}

.store {
  box-sizing: border-box;
  cursor: pointer;
  flex-shrink: 0;
  padding: 16px;
  position: relative;
  width: 336px;

  &.selected {
    background: var(--very-light-yellow);
  }

  & + & {
    &::before {
      border-bottom: 1px solid var(--border-color);
      content: '';
      display: inline-block;
      left: 0;
      margin: 0;
      position: absolute;
      right: 0;
      top: 0;

      @media screen and (max-width: 768px) {
        margin: 0 16px;
      }
    }
  }

  /* SP表示 */
  .sp & {
    font-weight: bold;
    width: 100%;
  }
}

.no-data {
  align-items: center;
  display: flex;
  height: 560px;
  justify-content: center;

  .sp & {
    flex: 1 1 auto;
  }
}

.logout {
  border-radius: 4px;
  font-size: 15px;
  height: 40px;
  line-height: 38px;
  width: 100%;

  .sp & {
    height: 55px;
    line-height: 53px;
    padding: 0 16px;
  }
}

footer {
  border-top: 1px solid var(--border-color);
  padding: 16px;

  .sp & {
    padding: 0;
  }
}
</style>
